import {
  PreviaCanalVendaVM,
  PreviaProdutoCanalVendaVM,
  ProdutoCatalogoCanalVendaVM
} from './canais-venda.models';

export function temPublicacaoCatalogoIfoodHabilitada(empresa: any): boolean {
  return [empresa?.integracoesIfood, empresa?.integracoes99Food].filter(Array.isArray).reduce(
    (todas, integracoes) => todas.concat(integracoes), []).some(
    (integracao: any) => integracao?.publicacaoCatalogoHabilitada === true &&
      integracao.desativado !== true
  );
}

export function produtoPodeSerSelecionadoParaPublicacao(
  item: ProdutoCatalogoCanalVendaVM
): boolean {
  if(item.situacaoPublicacao === 'PUBLICANDO' || item.situacaoPublicacao === 'ERRO') return false;
  return item.vinculo === 'SEM_VINCULO' || item.possuiDiferencas ||
    item.situacaoPublicacao === 'PENDENTE' || item.situacaoPublicacao === 'BLOQUEADO' ||
    (item.alteracoesCompartilhadas || []).some(adicional => adicional.situacao === 'PENDENTE');
}

export function altereSelecaoPagina(
  atual: ReadonlySet<number>,
  itens: ProdutoCatalogoCanalVendaVM[],
  selecionado: boolean
): Set<number> {
  const proxima = new Set<number>(Array.from(atual));
  itens.forEach(item => selecionado
    ? proxima.add(item.produtoId)
    : proxima.delete(item.produtoId));
  return proxima;
}

export function selecaoDaPaginaCompleta(
  selecionados: ReadonlySet<number>,
  itens: ProdutoCatalogoCanalVendaVM[]
): boolean {
  return itens.length > 0 && itens.every(item => selecionados.has(item.produtoId));
}

export function podeCriarLote(previa: PreviaCanalVendaVM | null): boolean {
  return !!previa && previa.publicaveis > 0 &&
    previa.itens.some(item => item.publicavel) &&
    previa.itens.every(item => item.publicavel || item.bloqueios.length > 0);
}

export function quantidadeAlteracoes(previa: PreviaProdutoCanalVendaVM): number {
  return (previa.diferencas || []).length;
}

export function rotuloCaminhoDiferenca(caminho: string): string {
  if(caminho === 'conteudo.imagem') return 'Imagem';
  if(caminho === 'conteudo.descricao') return 'Descrição';
  if(caminho === 'conteudo.nome') return 'Nome';
  if(caminho === 'conteudo.categoriaExternaId') return 'Categoria';
  if(caminho === 'comercial.preco' || caminho === 'comercial.precoOriginal') return 'Preço';
  if(caminho === 'comercial.vender') return 'Venda';
  if(caminho === 'comercial.disponivel') return 'Disponibilidade';
  if(/^estrutura\.gruposAdicionais\[[^\]]+\]\.opcoes\[/.test(caminho)) return 'Opção';
  if(/^estrutura\.gruposAdicionais\[/.test(caminho)) return 'Grupo de adicionais';
  return 'Conteúdo';
}
